module.exports = __webpack_public_path__ + "img/Rectangle2.011c54f.png";